import React from "react"
import { Link } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"

import getPrice from "../lib/getPrice"

const ProductGrid = (props) => { 
  return (
    <div className="column">
      <div className="columns is-multiline is-mobile">
        {/* product loop */}
        {props.collection.map((product) => (
          <div key={product.id} className="column is-one-third-tablet is-half-mobile">
            <Link to={`/collections/${props.handle}/products/${product.handle}/`}>
              <GatsbyImage image={product.images[0].gatsbyImageData} alt={product.images[0].altText || product.title}/>
              <div style={{marginTop: `1.25rem`}}>
                <div className="has-text-danger has-text-centered is-uppercase">{product.title}</div>
                <div className="has-text-dark has-text-centered">from {getPrice(product.priceRangeV2.minVariantPrice.amount)}</div>
              </div>
            </Link>
          </div>
        ))}
        <div className="column is-full has-text-centered">
          <button
            className="button"
            onClick={props.onCountChange}
          >
            Load more products
          </button>
        </div>
      </div>
    </div>
  )
}

export default ProductGrid